import { fixResponseJSON, filterParams } from '../assets/helpers/funciones'
import { authInstance } from './axios'
let url = process.env.REACT_APP_API_URL

export const membershipService = {
  getMembership: async (searchParam) => {
    const response = await authInstance
      .get(`${url}/memberships/search?searchParam=${searchParam}&limit=10`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  sendRenewalCode: async (customerId) => {
    const response = await authInstance
      .get(`${url}/memberships/sendRenewalCode?customerId=${customerId}`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  selfRenew: async (data, membershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${membershipId}/selfRenewal`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getMembershipById: async (membershipId, moduleType) => {
    const response = await authInstance
      .get(`${url}/memberships/${moduleType}/${membershipId}`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getLastServices: async (membershipId) => {
    const response = await authInstance
      .get(`${url}/services/getLatest?membership=${membershipId}`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getCancelReason: async (membershipType) => {
    const response = await authInstance
      .get(
        `${url}/cancellationReasons/search?type=${membershipType}&limit=1000`
      )
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  createMembership: async (data) => {
    const response = await authInstance
      .post(`${url}/memberships/create`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  sendDocuments: async (memebershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${memebershipId}/sendDocuments`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getMembershipsByStatus: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/findAll?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  calculateRenewalPrice: async (params, membershipId) => {
    const myInit = {
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
      },
      method: 'GET',
    }

    const response = await fetch(
      `${url}/memberships/${membershipId}/calculateRenewal?` +
        new URLSearchParams(filterParams(params)),
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response)
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  findRenewal: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/findRenewal?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getMembershipsCountByCondition: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/countByConditions?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getMembershipsCountRenewal: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/countRenewals?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getRCVs: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/getRcv?` + new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  upgradeMembership: async (data, memebershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${memebershipId}/upgrade`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  upgradeMembershipPaymet: async (data, memebershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${memebershipId}/payments`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getMembershipsToBeRenewed: async (params) => {
    const response = await authInstance
      .get(
        `${url}/memberships/findAllRenewal?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getMembershipCountByStatus: async (searchParam) => {
    const response = await authInstance
      .get(`${url}/memberships/totalByStatus`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  updateMembershipStatus: async (membershipId) => {
    const myInit = {
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'PUT',
    }

    const response = await fetch(
      `${url}/memberships/${membershipId}/updateStatus`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response)
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  updatePaymentTypeInRenewal: async (membershipId, data) => {
    const response = await authInstance
      ?.put(`${url}/memberships/${membershipId}/paymentType`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getSalesMembershipById: async (membershipId) => {
    const myInit = {
      headers: {
        'Content-type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'GET',
    }

    const response = await fetch(
      `${url}/memberships/sales/${membershipId}`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response)
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  updateImages: async (file, membershipId) => {
    const myInit = {
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      method: 'PUT',
      body: file,
    }

    const response = await fetch(
      `${url}/memberships/${membershipId}/updateImages`,
      myInit
    )
      .then(async (response) => {
        return fixResponseJSON(response)
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  updateMembership: async (data, membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/update`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  approveMembership: async (membershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${membershipId}/approve`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },
  cancelMembership: async (data, membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/cancel`, data)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  renewMembership: async (membershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${membershipId}/renew`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getStatuses: async () => {
    const response = await authInstance
      .get(`${url}/memberships/status`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  reativateMembership: async (membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/reactivate`, {})
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },
  rescueMembership: async (membershipId) => {
    const response = await authInstance
      .post(`${url}/memberships/${membershipId}/rescue`, {})
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  removeCode: async (membershipId) => {
    const response = await authInstance
      .put(`${url}/memberships/${membershipId}/removeCode`, {})
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },
}
